<div *ngIf="tooltip" class="wrapper">
  <i class="fas fa-info-circle infobutton" (click)="openDialog()"></i>
</div>
